import {
  Row,
  Col,
  Container,
  Form,
  Button,
  CloseButton,
  Table,
  Alert,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MaskedInput from 'react-text-mask';
import GoBackButton from "./GoBackButton";

const CreateDeliveryBookComponent = ({ createDeliveryBookApiRequest, getExtSalesUsers }) => {
  const [validated, setValidated] = useState(false);
  const [textDueDays, setTextDueDays] = useState("30")
  const [textQBCustomerId, setTextQBCustomerId] = useState("124")
  const [hasUniform, setHasUniform] = useState(false);
  const [createDeliveryBookResponseState, setCreateDeliveryBookResponseState] =
    useState({
      message: "",
      error: "",
    });
  const [abnNum, setAbnNum] = useState("")
  const abnMask = [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const [rowCount, setRowCount] = useState(1);
  const [extSalesUsers, setExtSalesUsers] = useState()

  useEffect(() => {
    const fetchExtSalesUsers = async () => {
      try {
        const data = await getExtSalesUsers();
        setExtSalesUsers(data);
      } catch (error) {
        console.error("Failed to fetch external sales users:", error);
      }
    };

    fetchExtSalesUsers();
  }, []);

  const handleNewDeliveryBook = () => {
    setRowCount(rowCount + 1);
  };
  const handleRemoveDeliveryBook = () => {
    setRowCount(rowCount - 1);
  };

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;

    const sites = [];
    for (
      let i = 0;
      i < document.querySelectorAll(".text-primary").length;
      i++
    ) {
      const name = document.getElementsByName(`name-${i}`)[0].value;
      const billingAddress = document.getElementsByName(
        `billingAddress-${i}`
      )[0].value;
      const deliveryAddress = document.getElementsByName(
        `deliveryAddress-${i}`
      )[0].value;
      const storeEmail = document.getElementsByName(`storeEmail-${i}`)[0].value.toLowerCase();
      sites.push({
        name,
        billingAddress,
        deliveryAddress,
        storeEmail,
      });
    }

    const formInputs = {
      companyName: form.companyName.value,
      emailHost: form.emailHost.value.toLowerCase(),
      billingEmail: form.billingEmail.value.toLowerCase(),
      companyAccount: form.companyAccount.value,
      dueDays: form.dueDays.value,
      quickBooksCutomerId: form.quickBooksCustomerId.value,
      sites: sites,
      abn: form.abn.value,
      hasUniform: hasUniform,
      signedBy: userInfo?.email
    };

    if (event.currentTarget.checkValidity() === true) {
      createDeliveryBookApiRequest(formInputs)
        .then((data) => {
          if (data.message === "Delivery Book Created")
            navigate("/admin/deliveryBooks");
        })
        .catch((er) => {
          setCreateDeliveryBookResponseState({
            error: er.response.data.message
              ? er.response.data.message
              : er.response.data,
          });
        });
    }
    setValidated(true);
  };
  const checkKeyDown = (e) => {
    if (e.code === "Enter") e.preventDefault();
  };

  const handleAbn = (e) => {
    const newValue = e.target.value;
    setAbnNum(newValue);
  };

  const handleToggle = (e) => {
    setHasUniform(e.target.checked);
  };

  return (
    <Container>
      <Row className="justify-content-md-center mt-5 content-container">
        <Row>
          <Col md={1}>
            {/* <Link to="/admin/deliveryBooks" className="btn btn-info my-3">
              Go Back
            </Link> */}
            <GoBackButton />
          </Col>
          <Col md={8}>
            <h1>Create New Address Book</h1>
            <Form
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
              onKeyDown={(e) => checkKeyDown(e)}
            >
              <Form.Group className="mb-3" controlId="formBasicCompanyName">
                <Form.Label>Company Name</Form.Label>
                <Form.Control name="companyName" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmailHost">
                <Form.Label>Email Host</Form.Label>
                <Form.Control name="emailHost" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicBillingEmail">
                <Form.Label>Billing Email</Form.Label>
                <Form.Control name="billingEmail" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicAbn">
                <Form.Label>Company ABN</Form.Label>
                <MaskedInput
                  mask={abnMask}
                  placeholder="ABN"
                  guide={false}
                  value={abnNum}
                  onChange={handleAbn}
                  render={(ref, props) => <Form.Control
                    required
                    minLength={14}
                    maxLength={14}
                    type="text"
                    name="abn"
                    ref={ref}
                    {...props}
                  />}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicCompanyAccount">
                <Form.Label>Company Account (Showing o Invoice)</Form.Label>
                <Form.Control name="companyAccount" required type="text" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicQuickBooksCustomerId">
                <Form.Label>QuickBooks Customer Id</Form.Label>
                <Form.Control name="quickBooksCustomerId" required type="text" value={textQBCustomerId} onChange={(e) => setTextQBCustomerId(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicDueDays">
                <Form.Label>Due Days</Form.Label>
                <Form.Control name="dueDays" required type="text" value={textDueDays} onChange={(e) => setTextDueDays(e.target.value)} />
              </Form.Group>
              {/* <Form.Group className="mb-3" controlId="formSignedBy">
                <Form.Label>Signed By</Form.Label>
                <Form.Control name="signedBy" disabled type="text" value={userInfo.isAdmin === true ? userInfo.email : ""} />
              </Form.Group> */}
              <Form.Group className="mb-3" controlId="formBasicHasUniform">
                <Form.Label>Has Uniform</Form.Label>
                <Form.Check
                  type="switch"
                  name="hasUniform"
                  label=""
                  checked={hasUniform}
                  onChange={handleToggle}
                />
              </Form.Group>

              {[...Array(rowCount)].map((_, index) => (
                <>
                  <span className="text-primary">Site: {index + 1}</span>
                  <Row>
                    <React.Fragment key={index}>
                      <Form.Group
                        as={Col}
                        md="3"
                        className="mb-3"
                        controlId={`formBasicName-${index}`}
                      >
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          as="textarea"
                          name={`name-${index}`}
                          required
                        />
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        className="mb-3"
                        controlId={`formBasicBillingAddress-${index}`}
                      >
                        <Form.Label>Billing Address </Form.Label>
                        <Form.Control
                          as="textarea"
                          name={`billingAddress-${index}`}
                          required
                        />
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        className="mb-3"
                        controlId={`formBasicDeliveryAddress-${index}`}
                      >
                        <Form.Label>Delivery Address </Form.Label>
                        <Form.Control
                          as="textarea"
                          name={`deliveryAddress-${index}`}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md="1" className="mb-3">
                        <i
                          className="bi bi-trash mt-3"
                          onClick={handleRemoveDeliveryBook}
                          style={{
                            cursor: "pointer",
                          }}
                        ></i>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="4"
                        className="mb-3"
                        controlId={`formBasicStoreEmail-${index}`}
                      >
                        <Form.Label>Store Email </Form.Label>
                        <Form.Control
                          type="text"
                          name={`storeEmail-${index}`}
                          required
                        />
                      </Form.Group>
                    </React.Fragment>
                  </Row>
                </>
              ))}
              <hr />
              <p
                onClick={handleNewDeliveryBook}
                style={{
                  cursor: "hand",
                  textAlign: "center",
                  fontStyle: "italic",
                  backgroundColor: "lightBlue",
                  cursor: "pointer"
                }}
              >
                Add New Site
              </p>
              <hr />

              <Button variant="primary" type="submit">
                Create
              </Button>

              <Link
                to="/admin/deliveryBooks"
                className="btn btn-secondary ms-5"
              >
                Cancel
              </Link>
              <p></p>
              {createDeliveryBookResponseState.error ?? ""}
            </Form>
          </Col>
        </Row>
      </Row>
    </Container>
  );
};

export default CreateDeliveryBookComponent;
